import { createCachedSelector } from "re-reselect";
import { createSelector } from "reselect";
export const profiles = (state) => state.persistent.profiles;
export const lastActiveProfiles = (state) => state.settings.profiles.lastActiveProfile;
export const activeGameId = (state) => {
    const profile = activeProfile(state);
    return profile !== undefined ? profile.gameId : undefined;
};
export const gameProfiles = createSelector(activeGameId, profiles, (gameId, profiles) => {
    return Object.keys(profiles)
        .filter((id) => profiles[id].gameId === gameId)
        .map((id) => profiles[id]);
});
export const activeProfileId = (state) => state.settings.profiles.activeProfileId;
export const nextProfileId = (state) => state.settings.profiles.nextProfileId;
export const activeProfile = (state) => {
    const profileId = activeProfileId(state);
    if (profileId === undefined) {
        return undefined;
    }
    return state.persistent.profiles[profileId];
};
const profileByIdImpl = createCachedSelector(profiles, (state, profileId) => profileId, (profilesIn, profileId) => profilesIn[profileId])((state, profileId) => profileId);
export function profileById(state, profileId) {
    if (profileId === undefined) {
        return undefined;
    }
    return profileByIdImpl(state, profileId);
}
export const enabledModCountForProfile = createCachedSelector((state) => state.persistent.mods, (state, profileId) => profileById(state, profileId), (mods, profile) => {
    if (profile?.modState === undefined) {
        return 0;
    }
    const gameMods = mods[profile.gameId] ?? {};
    return Object.keys(profile.modState).filter((id) => profile.modState[id]?.enabled &&
        gameMods[id]?.state === "installed").length;
})((state, profileId) => profileId ?? "___empty");
export const lastActiveProfileForGame = createCachedSelector(lastActiveProfiles, (state, gameId) => gameId, (lastActiveProfilesIn, gameId) => lastActiveProfilesIn[gameId])((state, gameId) => gameId);
